module.exports = __webpack_public_path__ + "img/UniSuper-logo_x3.2a63be88.png";